export default __webpack_public_path__ + "static/media/icons.f95f12b1.svg";